import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// 导入Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// 导入Element Plus图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 导入QRCode库
import QRCode from 'qrcode'

import App from './App.vue'
import router from './router'

// 导入调试工具（仅开发环境）
if (import.meta.env.DEV) {
  import('@/utils/debugPanel').then(m => m.setupDebugPanel())
}

// 导入全局样式
import '@/assets/styles/main.scss'
import '@/assets/styles/theme.css'

// 创建Pinia实例并使用持久化插件
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// 创建Vue应用实例
const app = createApp(App)

// 禁用 Vue 和库的冗余日志
app.config.warnHandler = () => null  // 禁用 Vue 警告
app.config.devtools = false  // 禁用开发工具警告

// 隐藏 Element Plus 的日志
window.__ELEMENT_PLUS_WARN__ = false

// 按顺序使用插件:先注册Pinia和Router,最后注册Element Plus
app.use(pinia)
app.use(router)
app.use(ElementPlus, { locale: zhCn, size: 'default' })

// 注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 配置QRCode全局属性
app.config.globalProperties.$QRCode = QRCode
window.QRCode = QRCode

// 全局错误处理
app.config.errorHandler = (err, vm, info) => {
  // 过滤 ResizeObserver 的良性错误
  if (err && err.message && err.message.includes('ResizeObserver loop completed')) {
    return
  }

  console.error('全局错误:', err, info)
  if (err) {
    console.error('错误详情:', err.message || err)
    console.error('错误堆栈:', err.stack)
  }
}

// 处理 ResizeObserver 错误
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver loop completed')) {
    event.preventDefault()
    return false
  }
})

// 挂载应用
app.mount('#app')
